import { capitalizeFirstChars } from "@pulse-ui/formatting";
import { getMargins, getParties } from "../helpers";
import { IAssetMarginReport } from "@pulse-ui/codegen/generated_ts/position_management";
import { IAGAssetMarginReportDataRow } from "../../../AlgoTable.types";
import { v4 as uuidv4 } from "uuid";

// asset_margin_ratio isn't on the wire type -- maintenance_margin/margin_balance is the schema's
// own definition of the ratio, so it's derived client-side from the margins the report already carries.
const computeAssetMarginRatio = (marginsGroup: ReturnType<typeof getMargins> | null): string => {
    const maintenanceMargin = parseFloat(marginsGroup?.maintenance_margin?.margin_amt ?? "");
    const marginBalance = parseFloat(marginsGroup?.margin_balance?.margin_amt ?? "");
    if (!Number.isFinite(maintenanceMargin) || !Number.isFinite(marginBalance) || marginBalance === 0) {
        return "-";
    }
    return ((maintenanceMargin / marginBalance) * 100).toString();
};

export const mapAssetMarginReport = (rpt: IAssetMarginReport): IAGAssetMarginReportDataRow => {
    const partiesGroup = rpt?.parties ? getParties(rpt.parties) : null;
    const marginsGroup = rpt?.margins ? getMargins(rpt.margins) : null;
    return {
        row_id: uuidv4(),
        rpt_type: rpt?.rpt_type?.toString() ? capitalizeFirstChars(rpt.rpt_type.toString().split("_")) : "-",
        current_date: rpt?.current_date ?? "-",
        asset: rpt?.asset ?? "-",
        asset_margin_ratio: computeAssetMarginRatio(marginsGroup),
        transact_time: rpt?.transact_time ?? "-",
        updated: rpt?.updated ?? "-",
        executing_firm: partiesGroup?.executing_firm?.party_id ?? "-",
        exchange: partiesGroup?.exchange?.party_id ?? "-",
        customer_account: partiesGroup?.customer_account?.party_id ?? "-",
        intermediary: partiesGroup?.intermediary?.party_id ?? "-",
        account_wallet: partiesGroup?.account_wallet?.party_id ?? "-",
        blockchain_wallet: partiesGroup?.blockchain_wallet?.party_id ?? "-",
        maintenance_margin: marginsGroup?.maintenance_margin?.margin_amt ?? "-",
        initial_margin: marginsGroup?.initial_margin?.margin_amt ?? "-",
        margin_balance: marginsGroup?.margin_balance?.margin_amt ?? "-",
        unrealized_pnl: marginsGroup?.unrealized_pnl?.margin_amt ?? "-",
        available_balance: marginsGroup?.available_balance?.margin_amt ?? "-",
    };
}